import { FC, useEffect } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps, InputNumber } from ".";
import FloatControlViewModel from "../Models/FloatControlViewModel";

interface IFloatControlProps extends IFormProps {
	model: FloatControlViewModel;
};

const FloatControl: FC<IFloatControlProps> = ( { model, readOnly, setFieldValue } ) => {

	const [ inputProps,,helperProps ] = useField( model.FullPath );

	useEffect( () => {
		helperProps.setValue( model.Value, true );
	// eslint-disable-next-line
	}, [ model.Value ] );

	const onChangeValue = ( value: any ) => setFieldValue( model.FullPath, value );

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling || readOnly }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<InputNumber
				{...inputProps}
				readOnly={readOnly || !model.ControlEnabling}
				step={0.1}
				withoutArrows
				min={model.MinValue}
				max={model.MaxValue}
				onChangeValue={onChangeValue}
				mode={"floating"}
				isClearBtn={false}
				isInvalid={!model.IsValid}
			/>
		</FieldGroup>
	);
};

export default FloatControl;
